module.exports = __webpack_public_path__ + "img/知识抽取.31a90012.jpg";